package com.rainbowclubs.rainbow.data.repositories

import com.rainbowclubs.rainbow.data.cache.AuthCache
import com.rainbowclubs.rainbow.data.cache.ClubCache
import com.rainbowclubs.rainbow.data.models.User
import com.rainbowclubs.rainbow.domain.repositories.UserRepository
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import io.ktor.client.*
import io.ktor.client.request.*
import io.ktor.http.*

class UserRepositoryImpl(
    private val httpClient: HttpClient,
    private val authCache: AuthCache,
    private val clubCache: ClubCache,
) : UserRepository {
    override suspend fun createUser(user: User): Result<Boolean> {
        val response = httpClient.post("/user") {
            contentType(ContentType.Application.Json)
            setBody(user)
        }
        return if (response.status.isSuccess()) {
            val userId = user.id
            if (!userId.isNullOrBlank()) {
                if (authCache.userUid != userId) {
                    clubCache.clear()
                }
                authCache.userUid = userId
            }
            Result.success(true)
        } else {
            Result.failure(Exception(response.status.description))
        }
    }

    override fun getCurrentUser(): User? {
        val firebaseUser = Firebase.auth.currentUser
            ?: return authCache.userUid?.let { cachedUserId ->
                User(
                    id = cachedUserId,
                    name = null,
                    email = null,
                    createdAt = null,
                )
            }

        return User(
            id = firebaseUser.uid,
            name = firebaseUser.displayName,
            email = firebaseUser.email,
            createdAt = null,
        )
    }
}
